import { render, staticRenderFns } from "./addDepartment.vue?vue&type=template&id=b9bc030e&scoped=true"
import script from "./addDepartment.vue?vue&type=script&lang=js"
export * from "./addDepartment.vue?vue&type=script&lang=js"
import style0 from "./addDepartment.vue?vue&type=style&index=0&id=b9bc030e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bc030e",
  null
  
)

export default component.exports